import React from "react";
import { Link } from "react-router-dom";
import panelMenuIcon from "../../assets/panel-menu.svg";

// Shared frame for the dashboard panels. `className` carries the per-panel
// background and flex sizing so the caller keeps the Figma values.
// `menuTo` turns the hamburger icon into a link to the panel's detail page.
// `titleClass` exists for panel names too long to sit at 40px on a phone.
export default function Panel({ title, className = "", titleClass = "text-[40px]", menuTo, children }) {
    return (
        <section className={`rounded-[10px] px-[38px] pb-[30px] flex flex-col ${className}`}>
            <div className="flex items-end justify-between pt-[32px]">
                <h2
                    className={`${titleClass} leading-none text-black tracking-[2px]`}
                    style={{ fontFamily: "Koulen, sans-serif" }}
                >
                    {title}
                </h2>
                {menuTo ? (
                    <Link to={menuTo} aria-label={`View ${title} details`}>
                        <img alt="" src={panelMenuIcon} className="w-[33px] h-[15px] mb-[8px]" />
                    </Link>
                ) : (
                    <img alt="" src={panelMenuIcon} className="w-[33px] h-[15px] mb-[8px]" />
                )}
            </div>
            <div className="border-t border-black mt-[14px]" />
            {children}
        </section>
    );
}
